// Player Set Actions
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const SET_ALERT = "SET_ALERT";
export const SET_CONTRACT_INSTANCE = "SET_CONTRACT_INSTANCE";
export const SET_WALLET = "SET_WALLET";
export const SET_WALLET_MODAL = "SET_WALLET_MODAL";
export const SET_IS_AUTH = "SET_IS_AUTH";